/* Helpdesk Workspace — utility helpers shared across panels. */

export const STATUS_LABEL = {
  NEW: "New enquiry",
  ASSIGNED: "Assigned",
  AWAITING_QUOTE: "Awaiting quote",
  QUOTE_REVIEW: "Quote review",
  REVIEWING: "Quote review",  // legacy alias
  AWAITING_INFO: "Awaiting info",
  APPROVED: "Approved",
  SCHEDULED: "Scheduled",
  IN_PROGRESS: "In progress",
  AWAITING_REVIEW: "Awaiting review",
  AWAITING_INVOICE: "Awaiting invoice",
  INVOICED: "Invoiced",
  PAID: "Paid",
  COMPLETED: "Completed",
  ADVISED: "Advised",
  CLOSED: "Closed",
  CANCELLED: "Cancelled",
};

export const STATUS_TONE = {
  NEW:              "bg-[#0F766E]/10 text-[#0F766E] border-[#0F766E]/30",
  ASSIGNED:         "bg-[#0F766E]/10 text-[#0F766E] border-[#0F766E]/30",
  AWAITING_QUOTE:   "bg-[#B88A2A]/15 text-[#B88A2A] border-[#B88A2A]/30",
  QUOTE_REVIEW:     "bg-[#B88A2A]/15 text-[#B88A2A] border-[#B88A2A]/30",
  REVIEWING:        "bg-[#B88A2A]/15 text-[#B88A2A] border-[#B88A2A]/30",
  AWAITING_INFO:    "bg-[#B88A2A]/15 text-[#B88A2A] border-[#B88A2A]/30",
  APPROVED:         "bg-[#064E2E]/10 text-[#064E2E] border-[#064E2E]/30",
  SCHEDULED:        "bg-[#0F766E]/15 text-[#0F766E] border-[#0F766E]/30",
  IN_PROGRESS:      "bg-[#0F766E]/15 text-[#0F766E] border-[#0F766E]/30",
  AWAITING_REVIEW:  "bg-[#B88A2A]/15 text-[#B88A2A] border-[#B88A2A]/30",
  AWAITING_INVOICE: "bg-[#B88A2A]/15 text-[#B88A2A] border-[#B88A2A]/30",
  INVOICED:         "bg-[#0F766E]/15 text-[#0F766E] border-[#0F766E]/30",
  PAID:             "bg-[#064E2E]/15 text-[#064E2E] border-[#064E2E]/30",
  COMPLETED:        "bg-[#064E2E]/15 text-[#064E2E] border-[#064E2E]/30",
  ADVISED:          "bg-[#064E2E]/10 text-[#064E2E] border-[#064E2E]/30",
  CLOSED:           "bg-[#475569]/15 text-[#475569] border-[#475569]/30",
  CANCELLED:        "bg-[#B91C1C]/10 text-[#B91C1C] border-[#B91C1C]/30",
};

export const SLA_TONE = {
  GREEN: { bg: "bg-[#064E2E]", text: "text-white", label: "On track", soft: "bg-[#064E2E]/10 text-[#064E2E]" },
  AMBER: { bg: "bg-[#B88A2A]", text: "text-white", label: "At risk",  soft: "bg-[#B88A2A]/15 text-[#B88A2A]" },
  RED:   { bg: "bg-[#B91C1C]", text: "text-white", label: "Overdue",  soft: "bg-[#B91C1C]/10 text-[#B91C1C]" },
};

export function fmtMoney(n) {
  if (n == null) return "—";
  return `£${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function fmtTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function relTime(iso) {
  if (!iso) return "";
  const t = new Date(iso).getTime();
  const seconds = Math.floor((Date.now() - t) / 1000);
  if (seconds < 60) return "just now";
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 2592000) return `${Math.floor(seconds / 86400)}d ago`;
  if (seconds < 31536000) return `${Math.floor(seconds / 2592000)}mo ago`;
  return `${Math.floor(seconds / 31536000)}y ago`;
}

export function shortId(id) {
  if (!id) return "";
  return id.slice(0, 8).toUpperCase();
}
